module.exports = __webpack_public_path__ + "media/country_flags/al-79abb342.png";